/**
 * Motion Accordion Enhancement
 * 
 * This script enhances accordion animations using Motion.js
 * It works with both the FAQ accordion and two-column FAQ sections
 */

document.addEventListener('DOMContentLoaded', initAccordions);
document.addEventListener('shopify:section:load', initAccordions);
window.addEventListener('load', initAccordions);

function initAccordions() {
  // console.log('Initializing accordions');
  
  // Check if Motion.js is available
  if (typeof Motion === 'undefined') {
    // console.error('Motion.js is not loaded. Accordion animations will not work.');
  } else {
    // console.log('Motion.js is loaded and available.');
  }
  
  // Check if Phosphor icons are loaded
  const testIcon = document.querySelector('.ph.ph-caret-down');
  if (testIcon) {
    // console.log('Phosphor icons found in the document:', testIcon);
    // console.log('Icon computed styles:', window.getComputedStyle(testIcon));
  } else {
    // console.log('No Phosphor icons found in the document. Check if the class names are correct.');
  }
  
  initFaqAccordions();
  initTwoColumnAccordions();
}

function initFaqAccordions() {
  // Get all FAQ items
  const faqItems = document.querySelectorAll('.faq-item');
  if (!faqItems.length) {
    // console.log('No FAQ items found. Check if the selectors are correct.');
    return;
  }
  
  // console.log(`Found ${faqItems.length} FAQ items`);
  
  // Process each FAQ item
  faqItems.forEach(function(item, index) {
    // Skip if already initialized
    if (item.hasAttribute('data-accordion-initialized')) {
      // console.log(`Item ${index} already initialized, skipping.`);
      return;
    }
    
    const summary = item.querySelector('summary');
    const content = item.querySelector('.faq-answer');
    const caretIcon = item.querySelector('.accordion-icon');
    
    // console.log(`Item ${index} - summary: ${summary ? 'found' : 'not found'}, content: ${content ? 'found' : 'not found'}, caretIcon: ${caretIcon ? 'found' : 'not found'}`);
    
    if (!summary || !content) return;
    
    // Set initial styles
    content.style.overflow = 'hidden';
    
    // Add styles for the caret icon
    if (caretIcon) {
      caretIcon.style.display = 'inline-block';
      caretIcon.style.transition = 'none'; // Remove transition to prevent conflicts with Motion.js
      // console.log(`Caret icon styles set for item ${index}`);
    } else {
      // console.warn(`No caret icon found for item ${index}. Check the HTML structure.`);
    }
    
    // Force close all items initially
    item.removeAttribute('open');
    content.style.height = '0px';
    content.style.opacity = '0';
    content.style.padding = '0';
    
    // Create a custom attribute to track our own open state
    item.setAttribute('data-custom-open', 'false');
    item.setAttribute('data-accordion-initialized', 'true');
    
    // Completely prevent the native details behavior
    item.addEventListener('click', function(e) {
      // Don't do anything if the click wasn't on the summary
      if (!e.target.closest('summary')) return;
      
      // Prevent the default toggle behavior
      e.preventDefault();
      e.stopPropagation();
    });
    
    // Prevent the toggle event from firing
    item.addEventListener('toggle', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, true);
    
    // Add our custom click handler to the summary element only
    summary.addEventListener('click', function(e) {
      // Prevent the default toggle behavior
      e.preventDefault();
      e.stopPropagation();
      
      // console.log(`Item ${index} summary clicked`);
      
      // Get all other open items
      const container = item.closest('.faq-container');
      if (container) {
        const siblings = Array.from(container.querySelectorAll('.faq-item')).filter(el => el !== item && el.getAttribute('data-custom-open') === 'true');
        
        // Close all other open items
        siblings.forEach(function(sibling) {
          const siblingContent = sibling.querySelector('.faq-answer');
          const siblingCaret = sibling.querySelector('.accordion-icon');
          
          if (siblingContent) {
            // Rotate caret back to default position
            if (siblingCaret) {
              // console.log('Rotating sibling caret back to 0deg');
              Motion.animate(siblingCaret, {
                rotate: '0deg'
              }, {
                duration: 0.3,
                easing: 'ease-out'
              });
            }
            
            // Get current height before closing
            const startHeight = siblingContent.offsetHeight;
            
            // Ensure we have a valid height to animate from
            if (startHeight > 0) {
              // Set the explicit start height to ensure animation works
              siblingContent.style.height = startHeight + 'px';
              
              // Force a reflow
              void siblingContent.offsetHeight;
              
              // Update state immediately to prevent double-click issues
              sibling.removeAttribute('open');
              sibling.setAttribute('data-custom-open', 'false');
              
              // Animate closing
              Motion.animate(siblingContent, {
                height: '0px',
                opacity: 0,
                padding: '0'
              }, {
                duration: 0.4,
                easing: 'ease-in-out'
              });
            } else {
              // Fallback if height is 0
              sibling.removeAttribute('open');
              sibling.setAttribute('data-custom-open', 'false');
            }
          }
        });
      }
      
      // Toggle the current item
      const isOpen = item.getAttribute('data-custom-open') === 'true';
      // console.log('Item clicked, current state:', isOpen);
      
      if (isOpen) {
        // Rotate caret back to default position
        if (caretIcon) {
          // console.log('Rotating caret back to 0deg');
          Motion.animate(caretIcon, {
            rotate: '0deg'
          }, {
            duration: 0.3,
            easing: 'ease-out'
          });
        }
        
        // Get current height before closing
        const startHeight = content.offsetHeight;
        // console.log('Closing item with height:', startHeight);
        
        // Update state immediately to prevent double-click issues
        item.setAttribute('data-custom-open', 'false');
        
        // Ensure we have a valid height to animate from
        if (startHeight > 0) {
          // Set the explicit start height to ensure animation works
          content.style.height = startHeight + 'px';
          
          // Force a reflow
          void content.offsetHeight;
          
          // Animate closing
          Motion.animate(content, {
            height: '0px',
            opacity: 0,
            padding: '0'
          }, {
            duration: 0.4,
            easing: 'ease-in-out',
            onComplete: function() {
              // console.log('Closing animation complete');
              // Remove open attribute after animation completes
              item.removeAttribute('open');
            }
          });
        } else {
          // Fallback if height is 0
          item.removeAttribute('open');
        }
      } else {
        // Rotate caret 180 degrees
        if (caretIcon) {
          // console.log('Rotating caret to 180deg');
          Motion.animate(caretIcon, {
            rotate: '180deg'
          }, {
            duration: 0.3,
            easing: 'ease-out'
          });
        }
        
        // Update state immediately to prevent double-click issues
        item.setAttribute('data-custom-open', 'true');
        item.setAttribute('open', '');
        
        // Measure the natural height
        content.style.height = 'auto';
        content.style.padding = '0 0 20px';
        content.style.opacity = '1';
        const height = content.offsetHeight;
        // console.log('Opening item to height:', height);
        
        // Reset to closed state for animation
        content.style.height = '0px';
        content.style.opacity = '0';
        
        // Force a reflow
        void content.offsetHeight;
        
        // Animate opening
        Motion.animate(content, {
          height: height + 'px',
          opacity: 1,
          padding: '0 0 20px'
        }, {
          duration: 0.4,
          easing: 'ease-out'
        });
      }
    });
    
    // Mark as initialized
    // console.log(`FAQ item ${index} initialized successfully`);
  });
}

function initTwoColumnAccordions() {
  // Get all collapsible rows
  const collapsibleRows = document.querySelectorAll('.collapsible-row');
  if (!collapsibleRows.length) return;
  
  // console.log(`Found ${collapsibleRows.length} collapsible rows`);
  
  // Process each collapsible row
  collapsibleRows.forEach(function(row) {
    // Skip if already initialized
    if (row.hasAttribute('data-accordion-initialized')) return;
    
    const header = row.querySelector('.collapsible-row-header');
    const content = row.querySelector('.collapsible-row-content');
    const caretIcon = row.querySelector('.accordion-icon');
    
    if (!header || !content) return;
    
    // Set initial styles
    content.style.overflow = 'hidden';
    
    // Add styles for the caret icon
    if (caretIcon) {
      caretIcon.style.display = 'inline-block';
      caretIcon.style.transition = 'none'; // Remove transition to prevent conflicts with Motion.js
    }
    
    // Force close all items initially
    row.setAttribute('aria-expanded', 'false');
    content.style.height = '0px';
    content.style.opacity = '0';
    content.style.padding = '0';
    
    // Create a custom attribute to track our own open state
    row.setAttribute('data-custom-open', 'false');
    row.setAttribute('data-accordion-initialized', 'true');
    
    // Add our custom click handler
    header.addEventListener('click', function() {
      // Get all other open items
      const container = row.closest('.faq-two-column-with-image__content');
      if (container) {
        const siblings = Array.from(container.querySelectorAll('.collapsible-row')).filter(el => el !== row && el.getAttribute('data-custom-open') === 'true');
        
        // Close all other open items
        siblings.forEach(function(sibling) {
          const siblingContent = sibling.querySelector('.collapsible-row-content');
          const siblingCaret = sibling.querySelector('.accordion-icon');
          
          if (siblingContent) {
            // Rotate caret back to default position
            if (siblingCaret) {
              Motion.animate(siblingCaret, {
                rotate: '0deg'
              }, {
                duration: 0.3,
                easing: 'ease-out'
              });
            }
            
            // Get current height before closing
            const startHeight = siblingContent.offsetHeight;
            
            // Ensure we have a valid height to animate from
            if (startHeight > 0) {
              // Set the explicit start height to ensure animation works
              siblingContent.style.height = startHeight + 'px';
              
              // Force a reflow
              void siblingContent.offsetHeight;
              
              // Update state immediately to prevent double-click issues
              sibling.setAttribute('aria-expanded', 'false');
              sibling.setAttribute('data-custom-open', 'false');
              
              // Animate closing
              Motion.animate(siblingContent, {
                height: '0px',
                opacity: 0,
                padding: '0'
              }, {
                duration: 0.4,
                easing: 'ease-in-out'
              });
            } else {
              // Fallback if height is 0
              sibling.setAttribute('aria-expanded', 'false');
              sibling.setAttribute('data-custom-open', 'false');
            }
          }
        });
      }
      
      // Toggle the current item
      const isOpen = row.getAttribute('data-custom-open') === 'true';
      
      if (isOpen) {
        // Rotate caret back to default position
        if (caretIcon) {
          Motion.animate(caretIcon, {
            rotate: '0deg'
          }, {
            duration: 0.3,
            easing: 'ease-out'
          });
        }
        
        // Get current height before closing
        const startHeight = content.offsetHeight;
        
        // Update state immediately to prevent double-click issues
        row.setAttribute('aria-expanded', 'false');
        row.setAttribute('data-custom-open', 'false');
        
        // Ensure we have a valid height to animate from
        if (startHeight > 0) {
          // Set the explicit start height to ensure animation works
          content.style.height = startHeight + 'px';
          
          // Force a reflow
          void content.offsetHeight;
          
          // Animate closing
          Motion.animate(content, {
            height: '0px',
            opacity: 0,
            padding: '0'
          }, {
            duration: 0.4,
            easing: 'ease-in-out'
          });
        }
      } else {
        // Rotate caret 180 degrees
        if (caretIcon) {
          Motion.animate(caretIcon, {
            rotate: '180deg'
          }, {
            duration: 0.3,
            easing: 'ease-out'
          });
        }
        
        // Update state immediately to prevent double-click issues
        row.setAttribute('aria-expanded', 'true');
        row.setAttribute('data-custom-open', 'true');
        
        // Measure the natural height
        content.style.height = 'auto';
        content.style.padding = '0 0 20px';
        content.style.opacity = '1';
        const height = content.offsetHeight;
        
        // Reset to closed state for animation
        content.style.height = '0px';
        content.style.opacity = '0';
        
        // Force a reflow
        void content.offsetHeight;
        
        // Animate opening
        Motion.animate(content, {
          height: height + 'px',
          opacity: 1,
          padding: '0 0 20px'
        }, {
          duration: 0.4,
          easing: 'ease-out'
        });
      }
    });
  });
}
